export default function enviaWhatsCancelado(numero, numerodopedido) {
  var prodWpp = null;
  prodWpp = "Pedido nº " + numerodopedido + "\n Foi cancelado";
  window.open(
    "https://api.whatsapp.com/send?phone=" + numero + "&text=" + prodWpp
  );
}
